import { render, staticRenderFns } from "./SheetUpload.vue?vue&type=template&id=1edb21e6&scoped=true&"
import script from "./SheetUpload.vue?vue&type=script&lang=ts&"
export * from "./SheetUpload.vue?vue&type=script&lang=ts&"
import style0 from "./SheetUpload.vue?vue&type=style&index=0&id=1edb21e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edb21e6",
  null
  
)

export default component.exports